
import XAddress from 'vux/src/components/x-address/index.vue'

import ChinaAddressData from "@/assets/china_address.json"; 
import SysUtils from "@/utils/sysUtils";
import AddressParse from "@/utils/address-parse";
import AddressService from "@/api/addressService";

export default {
data() {
return {
name: "", // 姓名
mobile: "", // 手机号
address: "", // 收货地址显示信息
addressDetails: "", // 详细地址
addressIds: [], // 地址选择器返回ids
addressNames: [], // 地址选择器返回names
addressData: ChinaAddressData,
showAddress: false, // 控制地址选择器显示隐藏
isSmart: false, // 是否智能识别过地址，识别操作置为true，地址选择器操作后置为false
smartAddress: "", // 只能识别地址信息
focus: false, // 控制识别区聚焦
};
},
computed: {
scene: function () {
return this.$route.query.type;
},
infoData: function () {
let value = this.$route.query.value;
if (value) {
value = JSON.parse(value);
}
return value;
},
},
mounted() {

if (this.infoData) {
document.title = "编辑地址";
this.name = this.infoData.receiverName;
this.mobile = this.infoData.mobile;
this.addressDetails = this.infoData.addr;
this.addressNames = [];
this.addressNames.push(this.infoData.provinceName);
this.addressNames.push(this.infoData.cityName);
this.addressNames.push(this.infoData.areaName);
this.addressIds = [];
this.addressIds.push(this.infoData.provinceId);
this.addressIds.push(this.infoData.cityId);
this.addressIds.push(this.infoData.areaId);
this.handleAddressStr();
}
},
methods: {
/**
* 点击textarea，取消placeholder显示，聚焦textarea
*/
clickTextarea() {
this.focus = true;
this.$refs.textarea.focus();
},
handleBlur() {
SysUtils.scrollPageView();
},
textareaBlur() {
if (!this.smartAddress) {
this.focus = false;
}
},
/**
* 点击清空操作
*/
handleClear() {
this.smartAddress = "";
this.focus = false;
},
/**
* 自动识别解析地址
* */
handleSmart() {
if (this.smartAddress) {
let parse_list = AddressParse.parse(this.smartAddress);
this.addressNames = [];
let province = ""; 
let city = ""; 
let county = ""; 
for (let i in parse_list) {
if (parse_list[i]) {
if (i == "name") {
this.name = parse_list[i];
} else if (i == "mobile") {
this.mobile = parse_list[i];
} else if (i == "addr") {
this.addressDetails = parse_list[i];
} else if (i == "province") {
this.addressNames.push(parse_list[i]);
province = parse_list[i];
} else if (i == "city") {
this.addressNames.push(parse_list[i]);
city = parse_list[i];
} else if (i == "area") {
this.addressNames.push(parse_list[i]);
county = parse_list[i];
}
}
}
let subIndex = province.indexOf("市");
if (subIndex != -1) {
province = province.slice(0, subIndex);
}
let tempProvinceId = "";
let tempCityId = "";
let tempCountyId = "";

for (let i = 0; i < this.addressData.length; i++) {
const ele = this.addressData[i];
if (ele.name == province) {
tempProvinceId = ele.value;
break;
}
}

for (let i = 0; i < this.addressData.length; i++) {
const ele = this.addressData[i];
if (ele.name == city) {
tempCityId = ele.value;
break;
}
}

for (let i = 0; i < this.addressData.length; i++) {
const ele = this.addressData[i];


if (ele.name == county && ele.parent == tempCityId) {
tempCountyId = ele.value;
break;
}
}

if (tempProvinceId && tempCityId && tempCountyId) {
this.addressIds = [];
this.addressIds.push(tempProvinceId);
this.addressIds.push(tempCityId);
this.addressIds.push(tempCountyId);
this.isSmart = true;
this.handleAddressStr();
} else {
this.$vux.toast.text("解析地址失败，请手动添加地址");
}
} else {
this.$vux.toast.text("请添加地址信息后再进行识别操作");
}
},
/**
* 根据addressNames合集处理页面上省市区显示
*/
handleAddressStr() {
this.address = "";
this.addressNames.forEach((item) => {
this.address += item + " ";
});
},
handleAddressHide(e) {
if (e) {
this.handleAddressStr();
this.isSmart = false;
}
},
/**
* 地址选择器初始化以及数据改变时都会触发此方法，可获取省市区名称及id
*/
handleAddressChange(ids, names) {
this.addressNames = names;
},
/**
* 校验各项数据
*/
checkFormInfo() {
if (this.name == "") {
this.$vux.toast.text("收件人不能为空");
return false;
} else if (this.mobile == "") {
this.$vux.toast.text("请检查收货人手机号");
return false;
} else if (this.address == "") {
this.$vux.toast.text("请选择收货地址");
return false;
} else if (this.addressDetails == "") {
this.$vux.toast.text("请填写收货人详细地址");
return false;
} else {
return true;
}
},
/**
* 点击保存
* 先校验各项数据是否已经填写
* 再调用接口执行保存操作
*/
clickSave() {
if (this.checkFormInfo()) {
var postData = {
receiverName: this.name,
mobile: this.mobile,
provinceId: this.addressIds[0],
cityId: this.addressIds[1],
areaId: this.addressIds[2],
addr: this.addressDetails,
setDefault: 0, // 默认设置为非默认
};
if (this.scene == "create") {

AddressService.create(postData)
.then((res) => {
this.$vux.toast.text("创建成功");
this.$router.go(-1);
})
.catch((err) => {
this.$vux.toast.text(err.msg);
});
} else {
postData.addrId = this.infoData.id;
AddressService.update(postData)
.then((res) => {
this.$vux.toast.text("修改成功");
this.$router.go(-1);
})
.catch((err) => {
this.$vux.toast.text(err.msg);
});
}
}
},
},
components: {
XAddress,
},
};



// WEBPACK FOOTER //
// ./src/views/address/editAddress.vue